import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { withTheme } from 'common/styling/theme';
import { getDynamicStyles, staticStyles } from './style';

const CurrentSubIBProgramsItem = ({ currentIBProgram, theme }) => {
  // Per-group expand/collapse state, keyed by group index
  const [expandedSections, setExpandedSections] = useState({});

  const [showTooltip, setShowTooltip] = useState(false);
  const [showPnLTooltip, setShowPnLTooltip] = useState(false);

  // Get the expand state for a specific group and section, default to true (expanded)
  const isSectionExpanded = (groupIdx, sectionName) => {
    if (expandedSections[groupIdx] && typeof expandedSections[groupIdx][sectionName] !== 'undefined') {
      return expandedSections[groupIdx][sectionName];
    }
    return true; // default expanded
  };

  const toggleSection = (groupIdx, sectionName) => {
    setExpandedSections(prev => ({
      ...prev,
      [groupIdx]: {
        ...(prev[groupIdx] || {}),
        [sectionName]: !isSectionExpanded(groupIdx, sectionName),
      },
    }));
  };

  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  // 获取子IB设置数据 (现在是数组格式)
  const rewardDataArray = currentIBProgram?.partnershipConditionsMultipleSub || [];

  // 映射reward_type到对应的显示文本
  const mapRewardTypeToText = rewardType => {
    const typeMap = {
      spread: 'Percentage for spread',
      fix: 'Fixed amount',
      percentage: 'Percentage for commissions',
    };
    return typeMap[rewardType] || rewardType || '';
  };

  return (
    <div>
      {Array.isArray(rewardDataArray) &&
        rewardDataArray.map((conditions, idx) => {
          const {
            symbolExceptionsFormat,
            groupExceptionsFormat,
            defaultReward,
            // eslint-disable-next-line camelcase
            table_type,
            pnlReward,
            netDepositReward,
          } = conditions;
          const programName = conditions?.program || '';

          return (
            <div key={idx} className="CurrentSubIBProgramsItem">
              {programName && (
                <div className="currentIBProgram">
                  <p className="program-name">
                    <span>
                      <strong>Program:</strong> {programName}
                    </span>
                    {/* eslint-disable-next-line camelcase */}
                    {table_type === 'master_a_book_table' && (
                      <p className="program-limitation">
                        (This program is limited to <strong>A-Book</strong> clients for calculation.)
                      </p>
                    )}
                    {/* eslint-disable-next-line camelcase */}
                    {table_type === 'master_b_book_table' && (
                      <p className="program-limitation">
                        (This program is limited to <strong>B-Book</strong> clients for calculation.)
                      </p>
                    )}
                  </p>
                  <button
                    type="button"
                    className={`arrow-icon ${isSectionExpanded(idx, 'currentIBProgram') ? 'expanded' : ''}`}
                    onClick={() => toggleSection(idx, 'currentIBProgram')}
                    style={{ cursor: 'pointer', border: 'none', background: 'none', padding: 0 }}
                    aria-expanded={isSectionExpanded(idx, 'currentIBProgram')}
                    aria-label={isSectionExpanded(idx, 'currentIBProgram') ? '收起区块' : '展开区块'}>
                    ›
                  </button>
                </div>
              )}

              {isSectionExpanded(idx, 'currentIBProgram') && (
                <>
                  {/* Default Reward 区块 */}
                  <div className="section">
                    <div className="section-header">
                      <h3 className="section-title">Default Reward</h3>
                      {programName === 'Percentage' && (
                        <div
                          className="info-icon-container"
                          onMouseEnter={() => setShowTooltip(true)}
                          onMouseLeave={() => setShowTooltip(false)}>
                          <div className="info-icon">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="10" cy="10" r="9.5" stroke="#2c008f" />
                              <path
                                d="M10.786 15H9.092V7.678H10.786V15ZM10.968 5.536C10.968 5.85333 10.8653 6.10533 10.66 6.292C10.4547 6.47867 10.212 6.572 9.932 6.572C9.64267 6.572 9.39533 6.47867 9.19 6.292C8.98467 6.10533 8.882 5.85333 8.882 5.536C8.882 5.20933 8.98467 4.95267 9.19 4.766C9.39533 4.57933 9.64267 4.486 9.932 4.486C10.212 4.486 10.4547 4.57933 10.66 4.766C10.8653 4.95267 10.968 5.20933 10.968 5.536Z"
                                fill="#2c008f"
                              />
                            </svg>
                          </div>
                          {showTooltip && (
                            <div className="tooltip">
                              Your reward = Your sub_IBs&apos; total commissions × Percentage
                            </div>
                          )}
                        </div>
                      )}
                      {programName === 'Profit & Loss' && (
                        <div
                          className="info-icon-container"
                          onMouseEnter={() => setShowPnLTooltip(true)}
                          onMouseLeave={() => setShowPnLTooltip(false)}>
                          <div className="info-icon">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="10" cy="10" r="9.5" stroke="#2c008f" />
                              <path
                                d="M10.786 15H9.092V7.678H10.786V15ZM10.968 5.536C10.968 5.85333 10.8653 6.10533 10.66 6.292C10.4547 6.47867 10.212 6.572 9.932 6.572C9.64267 6.572 9.39533 6.47867 9.19 6.292C8.98467 6.10533 8.882 5.85333 8.882 5.536C8.882 5.20933 8.98467 4.95267 9.19 4.766C9.39533 4.57933 9.64267 4.486 9.932 4.486C10.212 4.486 10.4547 4.57933 10.66 4.766C10.8653 4.95267 10.968 5.20933 10.968 5.536Z"
                                fill="#2c008f"
                              />
                            </svg>
                          </div>
                          {showPnLTooltip && (
                            <div className="tooltip">
                              If you lose, IB gets commission on loss × percentage. If you profit then lose, IB only
                              gets commission on losses beyond your profit.
                            </div>
                          )}
                        </div>
                      )}
                      {programName === 'Net Deposit Sharing' && (
                        <div
                          className="info-icon-container"
                          onMouseEnter={() => setShowTooltip(true)}
                          onMouseLeave={() => setShowTooltip(false)}>
                          <div className="info-icon">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg">
                              <circle cx="10" cy="10" r="9.5" stroke="#2c008f" />
                              <path
                                d="M10.786 15H9.092V7.678H10.786V15ZM10.968 5.536C10.968 5.85333 10.8653 6.10533 10.66 6.292C10.4547 6.47867 10.212 6.572 9.932 6.572C9.64267 6.572 9.39533 6.47867 9.19 6.292C8.98467 6.10533 8.882 5.536C8.882 5.20933 8.98467 4.95267 9.19 4.766C9.39533 4.57933 9.64267 4.486 9.932 4.486C10.212 4.486 10.4547 4.57933 10.66 4.766C10.8653 4.95267 10.968 5.20933 10.968 5.536Z"
                                fill="#2c008f"
                              />
                            </svg>
                          </div>
                          {showTooltip && (
                            <div className="tooltip">
                              Your reward = (Current net deposits - Accumulated net withdrawals) x Percentage or fixed
                              amount range.
                            </div>
                          )}
                        </div>
                      )}
                    </div>

                    {programName === 'Traded Volume' && Array.isArray(defaultReward) && (
                      <div className="rewards-card">
                        <div className="rewards-header">
                          <span className="header-text">Sub-IB</span>
                          <span className="header-text">Base reward for volume</span>
                          <span className="header-text">Base reward for spread</span>
                          <span className="header-text">Base reward for commissions</span>
                        </div>
                        {defaultReward.map((reward, index) => (
                          <div
                            key={index}
                            className="rewards-body"
                            style={{ borderTop: index > 0 ? '1px solid rgba(0, 0, 0, 0.15)' : 'none' }}>
                            <span className="reward-value">Level {index + 1}</span>
                            <span className="reward-value">{reward.base_for_volume ?? 0}USD</span>
                            <span className="reward-value">{reward.base_for_spread ?? 0}%</span>
                            <span className="reward-value">{reward.base_for_commissions ?? 0}%</span>
                          </div>
                        ))}
                      </div>
                    )}

                    {programName === 'Percentage' && Array.isArray(defaultReward) && (
                      <div className="percentage-rewards-container">
                        {defaultReward.map((reward, index) => (
                          <div key={index} className="percentage-reward-item">
                            <div className="subib-level">Level {index + 1}</div>
                            <div className="rewards-card-pnl">
                              <div className="rewards-body-pnl">
                                <span className="reward-value-pnl">{reward.percentage ?? 0}%</span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {programName === 'Profit & Loss' && pnlReward && (
                      <div className="pnl-rewards-container">
                        {pnlReward.reward_type === 'percentage' && Array.isArray(pnlReward.value) && (
                          <div className="percentage-rewards-container">
                            {pnlReward.value.map((percentage, index) => (
                              <div key={index} className="percentage-reward-item">
                                <div className="subib-level">Level {index + 1}</div>
                                <div className="rewards-card-pnl">
                                  <div className="rewards-body-pnl">
                                    <span className="reward-value-pnl">{percentage ?? 0}%</span>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                        {pnlReward.reward_type === 'tiered_rebate' && Array.isArray(pnlReward.value) && (
                          <div className="tiered-rebate-container-subib">
                            {/* Assuming the first tier's reward array length represents the total level count */}
                            {Array.from({ length: pnlReward.value[0]?.reward?.length || 0 }).map((_, levelIndex) => (
                              <div key={levelIndex} className="tiered-rebate-level-row">
                                <div className="subib-level-label">Level {levelIndex + 1}</div>
                                <div className="tiered-rebate-row">
                                  {pnlReward.value.map((tier, tierIndex) => {
                                    const prevTier = pnlReward.value[tierIndex - 1];
                                    const lossRange =
                                      tierIndex === 0
                                        ? `0 < -Loss ≤ ${tier.loss}`
                                        : `${prevTier.loss} < -Loss ≤ ${tier.loss}`;

                                    return (
                                      <div key={tierIndex} className="tiered-rebate-card">
                                        <div className="tiered-rebate-percentage">
                                          <span className="reward-value-pnl">{tier.reward[levelIndex] ?? 0}%</span>
                                        </div>
                                        <div className="tiered-rebate-range">{lossRange}</div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )}

                    {programName === 'Net Deposit Sharing' && netDepositReward && (
                      <div className="pnl-rewards-container">
                        {netDepositReward.reward_type === 'percentage' && Array.isArray(netDepositReward.value) && (
                          <div className="tiered-rebate-container-subib">
                            {Array.from({ length: netDepositReward.value[0]?.reward?.length || 0 }).map(
                              (_, levelIndex) => (
                                <div key={levelIndex} className="tiered-rebate-level-row">
                                  <div className="subib-level-label">Level {levelIndex + 1}</div>
                                  <div className="tiered-rebate-row">
                                    {netDepositReward.value.map((tier, tierIndex) => {
                                      const prevTier = netDepositReward.value[tierIndex - 1];
                                      const depositRange =
                                        tierIndex === 0
                                          ? `0 < Net Deposit ≤ ${tier.deposit}`
                                          : `${prevTier.deposit} < Net Deposit ≤ ${tier.deposit}`;

                                      return (
                                        <div key={tierIndex} className="tiered-rebate-card">
                                          <div className="tiered-rebate-percentage">
                                            <span className="reward-value-pnl">{tier.reward[levelIndex] ?? 0}%</span>
                                          </div>
                                          <div className="tiered-rebate-range">{depositRange}</div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}

                        {netDepositReward.reward_type === 'fix' && Array.isArray(netDepositReward.value) && (
                          <div className="tiered-rebate-container-subib">
                            {Array.from({ length: netDepositReward.value[0]?.reward?.length || 0 }).map(
                              (_, levelIndex) => (
                                <div key={levelIndex} className="tiered-rebate-level-row">
                                  <div className="subib-level-label">Level {levelIndex + 1}</div>
                                  <div className="tiered-rebate-row">
                                    {netDepositReward.value.map((tier, tierIndex) => {
                                      const prevTier = netDepositReward.value[tierIndex - 1];
                                      const depositRange =
                                        tierIndex === 0
                                          ? `0 < Net Deposit ≤ ${tier.deposit}`
                                          : `${prevTier.deposit} < Net Deposit ≤ ${tier.deposit}`;

                                      return (
                                        <div key={tierIndex} className="tiered-rebate-card">
                                          <div className="tiered-rebate-percentage">
                                            <span className="reward-value-pnl">{tier.reward[levelIndex] ?? 0}USD</span>
                                          </div>
                                          <div className="tiered-rebate-range">{depositRange}</div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Symbol Group Exceptions 区块 */}
                  {programName !== 'Percentage' &&
                    groupExceptionsFormat &&
                    typeof groupExceptionsFormat === 'object' &&
                    Object.keys(groupExceptionsFormat).length > 0 && (
                      <div className="section">
                        <div className="section-header">
                          <h3 className="section-title">Symbol Group Exceptions</h3>
                          <button
                            type="button"
                            className={`arrow-icon ${
                              isSectionExpanded(idx, 'symbolGroupExceptions') ? 'expanded' : ''
                            }`}
                            onClick={() => toggleSection(idx, 'symbolGroupExceptions')}
                            style={{ cursor: 'pointer', border: 'none', background: 'none', padding: 0 }}
                            aria-expanded={isSectionExpanded(idx, 'symbolGroupExceptions')}
                            aria-label={isSectionExpanded(idx, 'symbolGroupExceptions') ? '收起区块' : '展开区块'}>
                            ›
                          </button>
                        </div>

                        {/* 符号组异常表格 */}
                        {isSectionExpanded(idx, 'symbolGroupExceptions') && (
                          <div className="exceptions-table">
                            <div className="table-header">
                              <span className="table-header-cell">Name</span>
                              <span className="table-header-cell">Sub-IB</span>
                              <span className="table-header-cell">Reward</span>
                              <span className="table-header-cell">Reward Type</span>
                            </div>
                            {(() => {
                              if (groupExceptionsFormat && Array.isArray(groupExceptionsFormat.group_reward_items)) {
                                const groupedItems = [];
                                groupExceptionsFormat.group_reward_items.forEach(item => {
                                  if (item.reward_type === 'fix') {
                                    const existing = groupedItems.find(
                                      g => g.group_name === item.group_name && g.reward_type === 'fix'
                                    );
                                    if (existing) {
                                      existing.rewards.push(...(item.rewards || []));
                                    } else {
                                      groupedItems.push({ ...item, rewards: [...(item.rewards || [])] });
                                    }
                                  } else {
                                    groupedItems.push(item);
                                  }
                                });

                                const tableRows = [];

                                groupedItems.forEach((groupRewardItem, groupIndex) => {
                                  if (groupRewardItem.rewards && Array.isArray(groupRewardItem.rewards)) {
                                    const levels = [];
                                    if (groupRewardItem.reward_type === 'fix') {
                                      let maxLevels = 0;
                                      groupRewardItem.rewards.forEach(r => {
                                        if (Array.isArray(r.amount) && r.amount.length > maxLevels) {
                                          maxLevels = r.amount.length;
                                        }
                                      });
                                      for (let i = 0; i < maxLevels; i += 1) {
                                        levels.push({ levelIndex: i, isFix: true });
                                      }
                                    } else {
                                      groupRewardItem.rewards.forEach((r, idx) => {
                                        levels.push({ levelIndex: idx, isFix: false, reward: r });
                                      });
                                    }

                                    if (levels.length > 0) {
                                      tableRows.push(
                                        <div key={groupIndex} className="table-row" style={{ padding: '0 20px' }}>
                                          <div
                                            className="table-cell"
                                            style={{ display: 'flex', alignItems: 'center', padding: '15px 0' }}>
                                            {groupRewardItem.group_name}
                                          </div>
                                          <div
                                            style={{ gridColumn: 'span 2', display: 'flex', flexDirection: 'column' }}>
                                            {levels.map((levelObj, innerIdx) => {
                                              const i = levelObj.levelIndex;
                                              return (
                                                <div
                                                  key={innerIdx}
                                                  style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: '1fr 1fr',
                                                    gap: '20px',
                                                    padding: '15px 0',
                                                    borderTop: innerIdx > 0 ? '1px solid rgba(0, 0, 0, 0.15)' : 'none',
                                                  }}>
                                                  <div
                                                    className="table-cell"
                                                    style={{ display: 'flex', alignItems: 'center' }}>
                                                    Level {i + 1}
                                                  </div>
                                                  <div
                                                    className="table-cell"
                                                    style={{
                                                      display: 'flex',
                                                      flexDirection: 'column',
                                                      gap: '8px',
                                                      justifyContent: 'center',
                                                    }}>
                                                    {levelObj.isFix ? (
                                                      groupRewardItem.rewards.map((reward, rewardIndex) => {
                                                        const amountValue = Array.isArray(reward.amount)
                                                          ? reward.amount[i]
                                                          : i === 0
                                                          ? reward.amount
                                                          : null;
                                                        if (amountValue == null) return null;
                                                        return (
                                                          <div key={rewardIndex} className="reward-condition">
                                                            <div className="reward-value-1">
                                                              {amountValue || 0}
                                                              {groupRewardItem.reward_type === 'fix' ? 'USD' : '%'}
                                                            </div>
                                                            <div className="reward-condition-text">
                                                              {reward.content || ''}
                                                            </div>
                                                          </div>
                                                        );
                                                      })
                                                    ) : (
                                                      <div className="reward-condition">
                                                        <div className="reward-value-1">
                                                          {levelObj.reward.amount || 0}
                                                          {groupRewardItem.reward_type === 'fix' ? 'USD' : '%'}
                                                        </div>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              );
                                            })}
                                          </div>
                                          <div
                                            className="table-cell"
                                            style={{ display: 'flex', alignItems: 'center', padding: '15px 0' }}>
                                            {mapRewardTypeToText(groupRewardItem.reward_type)}
                                          </div>
                                        </div>
                                      );
                                    }
                                  }
                                });

                                return tableRows;
                              }
                              return [];
                            })()}
                          </div>
                        )}
                      </div>
                    )}

                  {/* Symbol Exceptions 区块 */}
                  {programName !== 'Percentage' &&
                    symbolExceptionsFormat &&
                    typeof symbolExceptionsFormat === 'object' &&
                    Object.keys(symbolExceptionsFormat).length > 0 && (
                      <div
                        className="section"
                        style={{
                          borderBottom: idx < rewardDataArray.length - 1 ? '2px solid rgba(44, 0, 143, 0.1)' : 'none',
                          paddingBottom: '30px',
                        }}>
                        <div className="section-header">
                          <h3 className="section-title">Symbol Exceptions</h3>
                          <button
                            type="button"
                            className={`arrow-icon ${isSectionExpanded(idx, 'symbolExceptions') ? 'expanded' : ''}`}
                            onClick={() => toggleSection(idx, 'symbolExceptions')}
                            style={{ cursor: 'pointer', border: 'none', background: 'none', padding: 0 }}
                            aria-expanded={isSectionExpanded(idx, 'symbolExceptions')}
                            aria-label={isSectionExpanded(idx, 'symbolExceptions') ? '收起区块' : '展开区块'}>
                            ›
                          </button>
                        </div>

                        {/* 符号异常表格 */}
                        {isSectionExpanded(idx, 'symbolExceptions') && (
                          <div className="exceptions-table">
                            <div className="table-header">
                              <span className="table-header-cell">Name</span>
                              <span className="table-header-cell">Sub-IB</span>
                              <span className="table-header-cell">Reward</span>
                              <span className="table-header-cell">Reward Type</span>
                            </div>
                            {(() => {
                              if (symbolExceptionsFormat && Array.isArray(symbolExceptionsFormat.group_reward_items)) {
                                const groupedItems = [];
                                symbolExceptionsFormat.group_reward_items.forEach(item => {
                                  if (item.reward_type === 'fix') {
                                    const existing = groupedItems.find(
                                      g => g.group_name === item.group_name && g.reward_type === 'fix'
                                    );
                                    if (existing) {
                                      existing.rewards.push(...(item.rewards || []));
                                    } else {
                                      groupedItems.push({ ...item, rewards: [...(item.rewards || [])] });
                                    }
                                  } else {
                                    groupedItems.push(item);
                                  }
                                });

                                const tableRows = [];

                                groupedItems.forEach((groupRewardItem, groupIndex) => {
                                  if (groupRewardItem.rewards && Array.isArray(groupRewardItem.rewards)) {
                                    const levels = [];
                                    if (groupRewardItem.reward_type === 'fix') {
                                      let maxLevels = 0;
                                      groupRewardItem.rewards.forEach(r => {
                                        if (Array.isArray(r.amount) && r.amount.length > maxLevels) {
                                          maxLevels = r.amount.length;
                                        }
                                      });
                                      for (let i = 0; i < maxLevels; i += 1) {
                                        levels.push({ levelIndex: i, isFix: true });
                                      }
                                    } else {
                                      groupRewardItem.rewards.forEach((r, idx) => {
                                        levels.push({ levelIndex: idx, isFix: false, reward: r });
                                      });
                                    }

                                    if (levels.length > 0) {
                                      tableRows.push(
                                        <div key={groupIndex} className="table-row" style={{ padding: '0 20px' }}>
                                          <div
                                            className="table-cell"
                                            style={{ display: 'flex', alignItems: 'center', padding: '15px 0' }}>
                                            {groupRewardItem.group_name}
                                          </div>
                                          <div
                                            style={{ gridColumn: 'span 2', display: 'flex', flexDirection: 'column' }}>
                                            {levels.map((levelObj, innerIdx) => {
                                              const i = levelObj.levelIndex;
                                              return (
                                                <div
                                                  key={innerIdx}
                                                  style={{
                                                    display: 'grid',
                                                    gridTemplateColumns: '1fr 1fr',
                                                    gap: '20px',
                                                    padding: '15px 0',
                                                    borderTop: innerIdx > 0 ? '1px solid rgba(0, 0, 0, 0.15)' : 'none',
                                                  }}>
                                                  <div
                                                    className="table-cell"
                                                    style={{ display: 'flex', alignItems: 'center' }}>
                                                    Level {i + 1}
                                                  </div>
                                                  <div
                                                    className="table-cell"
                                                    style={{
                                                      display: 'flex',
                                                      flexDirection: 'column',
                                                      gap: '8px',
                                                      justifyContent: 'center',
                                                    }}>
                                                    {levelObj.isFix ? (
                                                      groupRewardItem.rewards.map((reward, rewardIndex) => {
                                                        const amountValue = Array.isArray(reward.amount)
                                                          ? reward.amount[i]
                                                          : i === 0
                                                          ? reward.amount
                                                          : null;
                                                        if (amountValue == null) return null;
                                                        return (
                                                          <div key={rewardIndex} className="reward-condition">
                                                            <div className="reward-value-1">
                                                              {amountValue || 0}
                                                              {groupRewardItem.reward_type === 'fix' ? 'USD' : '%'}
                                                            </div>
                                                            <div className="reward-condition-text">
                                                              {reward.content || ''}
                                                            </div>
                                                          </div>
                                                        );
                                                      })
                                                    ) : (
                                                      <div className="reward-condition">
                                                        <div className="reward-value-1">
                                                          {levelObj.reward.amount || 0}
                                                          {groupRewardItem.reward_type === 'fix' ? 'USD' : '%'}
                                                        </div>
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              );
                                            })}
                                          </div>
                                          <div
                                            className="table-cell"
                                            style={{ display: 'flex', alignItems: 'center', padding: '15px 0' }}>
                                            {mapRewardTypeToText(groupRewardItem.reward_type)}
                                          </div>
                                        </div>
                                      );
                                    }
                                  }
                                });

                                return tableRows;
                              }
                              return [];
                            })()}
                          </div>
                        )}
                      </div>
                    )}
                </>
              )}
            </div>
          );
        })}

      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </div>
  );
};

CurrentSubIBProgramsItem.propTypes = {
  currentIBProgram: PropTypes.object,
  theme: PropTypes.object,
};

CurrentSubIBProgramsItem.defaultProps = {
  currentIBProgram: {},
  theme: {},
};

export default withTheme()(CurrentSubIBProgramsItem);
